export enum DelegationType {
    InAppNotifications = 1,
    InAppImpersonation = 2
}

//TODO: remove with Auth0DelegateNovaImpersonationPermission Feature Flag cleanup
export const DelegationTypeOptions = [
    { key: DelegationType.InAppNotifications, value: 'Notifications' },
    { key: DelegationType.InAppImpersonation, value: 'Impersonation (Beta)' }
];

export const DelegationNoTimeSelectedDefault = {
    StartHour: 0,
    StartMinute: 0,
    EndHour: 23,
    EndMinute: 55
};
